/*eslint-disable*/
/* eslint-disable react/prop-types */
/* eslint-disable quotes */
import React from "react";
import { useState, useContext , useEffect } from "react";
import assets from "assets";
import PropTypes from "prop-types";
import {
  AppBar,
  CssBaseline,
  Drawer,
  Hidden,
  IconButton,
  Toolbar,
  Typography,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import MenuIcon from "@material-ui/icons/Menu";
import AppMenu from "../views/AppMenu";
import { useSelector, useDispatch } from "react-redux";

// import { features, dateStyle, language } from "config";
import { FirebaseContext } from "common";

const drawerWidth = 260;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
      color: "#0066c4",
    },
  },
  inputIconsColor: {
    color: "#0066c4",
  },
  appBar: {
    marginLeft: drawerWidth,

    // [theme.breakpoints.up("sm")]: {
    //   width: `calc(100% - ${drawerWidth}px)`,
    // },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },

  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
    background: "#6b7a83",
    // background: 'black',
    color: "white",
  },
  wrapper: {
    display: "flex",
    FlexDirection: "row",
  },

  content: {
    flexGrow: 1,
    padding: theme.spacing(4),
  },
}));

function ResponsiveQueueDrawer(props) {
  const { api } = useContext(FirebaseContext);
  const { container } = props;
  const classes = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  let time = new Date().toLocaleTimeString();
  const [ctime, setTime] = useState(time);
  const auth = useSelector((state) => state.auth);

  const UpdateTime = () => {
    time = new Date().toLocaleTimeString();
    setTime(time);
  };
  setInterval(UpdateTime);

  function handleDrawerToggle() {
    setMobileOpen(!mobileOpen);
  }

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar
          style={{
            display: "flex",
            justifyContent: "flex-end",
            backgroundColor: "#0066c4",
          }}
        >
          {/* <IconButton
            
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton> 
          <Typography variant="h6" noWrap>
              {AppDetails.app_name} 
          </Typography> */}

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              backgroundColor: "#0066c4",
            }}
          >
            <img
              style={{
                width: "80px",
                height: "80px",
              }}
              src={assets.logo192x192}
              alt="Logo"
            />
          </div>
          <div
            style={{
              display: "flex",
              flex: 3,
              flexDirection: "column",
              justifyContent: "flex-end",
            }}
          >
            <div>
              <Typography variant="h6" noWrap>
                {auth.info.profile.practiceName + "    "}
              </Typography>
            </div>
            <div>
              <Typography variant="h6" noWrap>
                {auth.info.profile.clinic}
              </Typography>
            </div>

            <div>
              <Typography variant="h6" noWrap>
                {ctime}
              </Typography>{" "}
            </div>
          </div>
        </Toolbar>
      </AppBar>
      {/* <nav className={classes.drawer} aria-label="mailbox folders">
        The implementation can be swapped with js to avoid SEO duplication of links.
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            anchor={theme.direction === "rtl" ? "right" : "left"}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            style={{ color: "#4c4b4b" }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
           
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            
          </Drawer>
        </Hidden>
      </nav> */}
      <main className={classes.content}>
        <div className={classes.toolbar} />
        {props.children}
      </main>
    </div>
  );
}

ResponsiveQueueDrawer.propTypes = {
  container: PropTypes.instanceOf(
    typeof Element === "undefined" ? Object : Element
  ),
};

export default ResponsiveQueueDrawer;
